export const INSTALLED_PRODUCTS_QUERY_KEY = 'installedProducts';

export const installedProductsKeys = {
  all: [INSTALLED_PRODUCTS_QUERY_KEY],
  lists: token => [...installedProductsKeys.all, 'list', token],
  tags: (token, turbineSerialNumber) => [
    ...installedProductsKeys.all,
    'tags',
    token,
    turbineSerialNumber
  ],
  listByFilters: (filters, token) => [
    ...installedProductsKeys.lists(),
    { filters },
    token
  ],
  details: token => [...installedProductsKeys.all, 'detail', token],
  detailById: (id, token) => [...installedProductsKeys.details(), id, token],
  detailByIdWithFilters: (id, filters, token) => [
    ...installedProductsKeys.details(),
    id,
    { filters },
    token
  ]
};
